// ============================================
// UI Slice - управление UI состоянием (уведомления, edit mode)
// ============================================

import { StateCreator } from 'zustand';

export interface Notification {
  type: string;
  message: string;
}

export interface UIState {
  // UI state
  notification: Notification | null;
  notificationTimeoutId: ReturnType<typeof setTimeout> | null;
  editMode: boolean;
  
  // UI actions
  showNotification: (type: string, message: string) => void;
  clearNotification: () => void;
  setEditMode: (mode: boolean) => void;
}

export const createUISlice: StateCreator<UIState, [], [], UIState> = (set, get) => ({
  // Initial state
  notification: null,
  notificationTimeoutId: null,
  editMode: false,
  
  // Show notification
  showNotification: (type: string, message: string) => {
    const currentTimeoutId = get().notificationTimeoutId;
    if (currentTimeoutId) {
      clearTimeout(currentTimeoutId);
    }
    
    set({ notification: { type, message } });
    
    const timeoutId = setTimeout(() => {
      set({ notification: null, notificationTimeoutId: null });
    }, 5000);
    
    set({ notificationTimeoutId: timeoutId });
  },
  
  // Clear notification
  clearNotification: () => {
    const currentTimeoutId = get().notificationTimeoutId;
    if (currentTimeoutId) {
      clearTimeout(currentTimeoutId);
    }
    set({ notification: null, notificationTimeoutId: null });
  },
  
  // Set edit mode
  setEditMode: (mode: boolean) => {
    set({ editMode: mode });
  }
});
